'use client';

import type { ReactNode } from "react";
import clsx from "clsx";

interface BadgeProps {
    readonly children: ReactNode;
    readonly tone?: "neutral" | "brand" | "warning" | "success";
    readonly className?: string;
}

const toneStyles: Record<NonNullable<BadgeProps["tone"]>, string> = {
    neutral: "bg-white/10 text-white/80 border-white/20",
    brand: "bg-brand-primary/15 text-brand-primary border-brand-primary/30",
    warning: "bg-amber-500/15 text-amber-300 border-amber-500/40",
    success: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40"
};

export function Badge({ children, tone = "neutral", className }: BadgeProps) {
    return (
        <span
            className={clsx(
                "inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em]",
                toneStyles[tone],
                className
            )}
        >
            {children}
        </span>
    );
}
